export default __webpack_public_path__ + "static/media/phone.b90c2b50.svg";